<template>
	<div>
		<minhead :headtitle="headtitle"></minhead>
		<el-dialog title="接口明细" :visible.sync="jkmxdiag"  width="900px" :close-on-click-modal="false" v-dialogDrag>
			<!-- <minhead :headtitle="jkmxtitle"></minhead> -->
			<div class="Centerhorizontally diagallx">
				<div>
					<div>入参:</div>
					<div class="divShow">
            {{ requestData}}
					</div>
				</div>
				<div style="margin-left: 68px;">
					<div>出参:</div>
					<div class="divShow">
            {{ responseData}}
					</div>
				</div>
			</div>
      <div class="diagallx">
        <span>当前请求路径:</span><a>{{requestUrl}}</a>
      </div>
			<div style="margin-top: 50px;padding-bottom: 28px;" class="between-line">
				<div></div>
				<div class="rightbuttom">
					<div @click="jkmxdiag = false">关闭</div>
				</div>
			</div>
		</el-dialog>
		<div class="areacontent">
			<div class="between-line">
				<div class="Centerupdown">
					<el-date-picker
							v-model="requestTime"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							value-format="yyyyMMdd"
							end-placeholder="结束日期" @change="getDataByParam">
					</el-date-picker>
				</div>
				<div class="Centerupdown">
<!--					<el-select v-model="requestState" style="width: 140px;" @change="getDataByParam">
						<el-option label="全部" value=""></el-option>
						<el-option label="成功" value="1"></el-option>
						<el-option label="失败" value="2"></el-option>
					</el-select>
					<el-select v-model="type" style="width: 140px;" @change="getDataByParam">
						<el-option label="全部" value=""></el-option>
						<el-option label="添加" value="1"></el-option>
						<el-option label="修改" value="2"></el-option>
						<el-option label="删除" value="3"></el-option>
						<el-option label="查询" value="4"></el-option>
					</el-select>-->
					<el-input style="width: 350px;margin-left: 20px;margin-right: 16px;" placeholder="业务操作、描述、操作人" prefix-icon="el-icon-search" v-model="serchval" clearable @input="getDataByParam"></el-input>
					<!-- <el-button type="primary" plain  @click="forrestsgai"  style="width: 100px;">重置</el-button> -->
					<div class="addstyle" style="width: 100px;" @click="forrestsgai">
						<samp>	重置
						</samp>
					</div>
				</div>

			</div>
			<div class="areatable">
				<div class="tableh">
				<el-table :data="tableData" border style="width: 100%" height="calc(100vh - 262px )" ref="multipleTable">
          <el-table-column prop="requestTime" label="请求时间" align="center">
            <template slot-scope="scope">
              {{stringtostmp( scope.row.requestTime)}}
            </template>
          </el-table-column>
			<el-table-column prop="type" label="业务操作" align="center">
				<template slot-scope="scope">
              {{typetostring( scope.row.type)}}
            </template>
			</el-table-column>
          <el-table-column prop="requestState" label="请求状态" align="center">
            <template slot-scope="scope">
              {{statetostring( scope.row.requestState)}}
            </template>
          </el-table-column>
          <el-table-column prop="timeConsuming" label="处理时长（毫秒）" align="center"></el-table-column>
					<el-table-column prop="operator" label="操作人" align="center"></el-table-column>
          <el-table-column prop="describetxt" label="描述" align="center"></el-table-column>
					<el-table-column  label="操作" align="center">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click=forseemx(scope.row)>查看详情</el-button>
						</template>
					</el-table-column>
				</el-table>
				</div>
				<div class="buttompage">
					<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:page-sizes="[10, 20, 100, 500]"
							:page-size="pagenum"
							layout="total, sizes, prev, pager, next, jumper"
							:total="totalcount"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				jkmxdiag:false,
				page: 1,
				pagenum: 10,
				totalcount: 10,
				tableData: [],
				headtitle: ['日志管理', '接口日志'],
				jkmxtitle: ['接口明细'],
				serchval: '',
				requestTime:[],
				requestData:'',
				responseData:'',
				requestState:'',
        requestUrl:"",
				type:'',
				tableHeight:""
			};
		},
		created() {
			this.getDataByParam();
		},
		mounted() {
			 this.$nextTick(() =>{
				this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
				window.onresize = () =>{
			    this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
			      }
			    })
		},
		methods: {
			forseemx(row){
				this.requestData='';
				this.responseData='';
				this.jkmxdiag=true
				this.requestData=row.requestData;
				this.responseData=row.responseData;
				this.requestUrl=row.url;
			},
			handleSizeChange(val) {
				this.pagenum = val;
				this.getDataByParam();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getDataByParam();
			},
			getDataByParam(){
				let param={}
				param.pagenum = this.pagenum;
				param.page = this.page;
				param.serchval=this.serchval;
				console.log(this.requestTime);
				if (this.requestTime &&this.requestTime.length==2){
					param.requestTime=this.requestTime[0]+"000000"+","+this.requestTime[1]+"235959";
				}
				if (this.requestState&&this.requestState!=""){
					param.requestState=this.requestState;
				}
				if (this.requestState&&this.requestState!=""){
					param.requestState=this.requestState;
				}
        let userobj=JSON.parse(localStorage.getItem("useropj"));
        let qiybh=userobj.currCompany.code;
        param.qiybh=qiybh;
				/*this.$https.fetchPost('logsdk/getOperationLogByData', param).then(res => {
					this.tableData = res.data.obj.data;
					this.totalcount = res.data.obj.count;
				});*/
				this.$https.fetchPost('log/getOperationLogByData', param).then(res => {
					this.tableData = res.data.obj.data;
					this.totalcount = res.data.obj.count;
				});
			},
			statetostring(value){
				let valueformat='';
				switch(value) {
					case "1":
						valueformat="成功"
						break;
					case "2":
						valueformat="失败"
						break;
						default:
            valueformat=value;

				}
				return valueformat;
			},
			typetostring(value){
			    switch (value){
			        case "1": return "添加"
                    case "2": return "修改"
                    case "3": return "删除"
                    case "4": return "查询"
                    default : return ''
                }
			},
			forrestsgai(){
				this.requestTime="";
				this.serchval="";
				this.type="";
				this.requestState="";
				this.getDataByParam();
			}
		}
	};
</script>

<style scoped="scoped" lang="less">
	.diagallx>div{
		display: flex;
	}
	.diagallx>div>div{
		font-size: 15px;
		margin-right: 23px;
		font-weight: bold;
		color: #333333;

	}
	// /deep/.el-dialog__body {
	// 	padding: 0;
	// }
	/deep/.el-table--small td {
		padding: 4px 0;
	}
	/deep/.el-table__body-wrapper {
		min-height: 160px;
	}

	/deep/.el-dialog__header {
		display: none;
	}
	.areatable {
		margin-top: 27px;
	}
	.areacontent {
		margin-left: 21px;
	}
  .divShow{
    border: #72767b;
    width: 300px;
    height: 300px;
    overflow-y:auto;
    overflow-x:auto;
  }
</style>
